module.exports = __webpack_public_path__ + "img/4.026cb7af.jpeg";